import { FC } from "react";
import { KolNav } from "@public-ui/react";
import { headerRoutes } from "../../router/headerRoutes.ts";
import { useRoutedKolibriLinks } from "@/lib/kolibri/utils/kolibri.ts";

interface IHeaderNavbarProps {
    onNavigation: () => void;
}

export const HeaderNavbar: FC<IHeaderNavbarProps> = ({ onNavigation }) => {
    // const visibleRoutes = usePermittedRoutes(headerRoutes);
    const links = useRoutedKolibriLinks(headerRoutes || [], {}, onNavigation);
    if (links.length === 0) {
        return null;
    }
    return <KolNav _label="Navigation" className="header-navbar" _links={links} />;
};
